module.exports = __webpack_public_path__ + "static/media/02.8fa13011.webp";